import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  LoadingHead: {
    VocTyp: "",
    VocTypName: "",
    VocNo: 0,
    PostDate: new Date(),
    Party: "",
    PartyName: "",
    TruckName: "",
    Drive: "",
    LoadingBay: "",
    Status: "",
    LoadingBayCode: "",
    Loc: "",
  },
  PalltetHead: {
    VocTyp: "",
    VocTypName: "",
    VocNo: 0,
    PostDate: new Date(),
    Party: "",
    PartyName: "",
    TruckName: "",
    Drive: "",
    LoadingBay: "",
    Status: "",
    LoadingBayCode: "",
    location:'',
    locationName:'',
    Loc: "",
  },
  
  LoadingList: [
    {
      DocTypCode: "",
      DocTypName: "",
      Date: "",
      Status: "",
    },
  ],
  LoadingData: {
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    statusVal: "",
    Scan: "",
  },
};

const SliceLoading = createSlice({
  name: "Loading",
  initialState: { value: initialState },

  reducers: {
    LoadingHead_Set: (state, action) => {
      state.value.LoadingHead = action.payload;
    },
    PalletHead_Set: (state, action) => {
      state.value.PalltetHead = action.payload;
    },
    
    LoadingHead_Status_Set: (state, action) => {
      state.value.LoadingHead.Status = action.payload.Status;
    },
    LoadingList_Set: (state, action) => {
      state.value.LoadingList = action.payload;
    },
    LoadingData_Set: (state, action) => {
      state.value.LoadingData = action.payload;
    },
    LoadingData_OnLoad_Set: (state, action) => {
      state.value.LoadingData = action.payload;
    },
    Loading_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const {
  LoadingHead_Set,
  Loading_Init,
  LoadingList_Set,
  LoadingData_Set,
  LoadingHead_Status_Set,
  LoadingData_OnLoad_Set,
  PalletHead_Set
} = SliceLoading.actions;
export default SliceLoading.reducer;
